interface SalesCTAProps {
  label: string;
  /** Resolved destination URL (booking link or wa.me). */
  href: string;
  onDismiss: () => void;
}

/**
 * Dismissible "connect with sales" card surfaced inside the chat flow after a
 * configured number of conversation rounds. Opens the tenant's sales channel in
 * a new tab. Rendered only when a destination URL could be resolved.
 */
export function SalesCTA({ label, href, onDismiss }: SalesCTAProps) {
  return (
    <div class="relative flex items-center gap-3 rounded-xl border border-[var(--primary)]/30 bg-[var(--primary)]/5 px-3 py-2.5">
      <a
        href={href}
        target="_blank"
        rel="noopener noreferrer"
        class="flex-1 inline-flex items-center justify-center gap-1.5 rounded-lg bg-[var(--primary)] px-3 py-2 text-xs font-medium text-[var(--primary-foreground)] transition-opacity hover:opacity-90 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[var(--ring)]"
      >
        {label}
        <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
          <path d="M7 17 17 7M9 7h8v8" />
        </svg>
      </a>
      <button
        type="button"
        onClick={onDismiss}
        aria-label="Dismiss"
        class="shrink-0 size-6 rounded-md flex items-center justify-center text-[var(--muted-foreground)]/70 hover:text-[var(--muted-foreground)] hover:bg-[var(--muted-foreground)]/10 transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[var(--ring)]"
      >
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
          <path d="M18 6 6 18M6 6l12 12" />
        </svg>
      </button>
    </div>
  );
}
